import { getSpreadersGradesList } from '@/api/yzdPlatformManage/promoterManage';
import { getsubjectList } from '@/api/yzdPlatformManage/userManage';

export const agentLevelMixin = {
  data() {
    return {
      leaveList: [],
      subjectList: []
    };
  },
  mounted() {
    this.getSpreadersGrades();
    this.getsubjectList();
  },
  methods: {
    getSpreadersGrades() {
      getSpreadersGradesList().then(res => {
        if (res.code === '0') {
          this.leaveList = res.data;
        }
      });
    },
    getsubjectList() {
      getsubjectList().then(res => {
        if (res.code === '0') {
          this.subjectList = res.data;
        }
      });
    }
  }
};
